import { observable, action, runInAction } from 'mobx';
import { PagedList, RootStore } from '..';
import { fetchWrapper } from '../../common/Fetch';
import { formatDateJson } from '../../common/Formatting';


export interface Report3Item {
    userId: string;
    customerFio: string;
    phoneNumber: string;
    email: string;
    siteName: string;
    organization: string;
    sum: number;
    count: number;

    brands: Report3BrandInfoItem[];
}

export interface Report3BrandInfoItem {
    brandGroupId: number;
    brandGroupName: string;
    count: number;
    sum: number;

}


export class Report3Store {


    _rootStore: RootStore;

    @observable items: Report3Item[] = [];

    @observable brandsCurrentPage = 1;
    @observable brandsTotalItemsCount = 1;
    @observable brandsPageSize = 25;

    @observable currentPage = 1;
    @observable totalOrdersCount = 1;


    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }


    @action
    loadData(managerIds: string[], statuses: number[], source?: string, customerId?: string, dateFrom?: Date, dateTo?: Date, page = 1) {
        this.items = [];
        const managerIdsParam = managerIds.length <= 0 ? "" : "&managerIds=" + managerIds.join("&managerIds=");
        const statusesParam = statuses.length <= 0 ? "" : "&statuses=" + statuses.join("&statuses=");
        const dateFromStr = dateFrom == undefined ? '' : formatDateJson(dateFrom);
        const dateToStr = dateTo == undefined ? '' : formatDateJson(dateTo);

        fetchWrapper(`api/report3/getdata?source=${source}&page=${page}&customerId=${customerId == undefined ? '' : customerId}&dateFrom=${dateFromStr}&dateTo=${dateToStr}${managerIdsParam}${statusesParam}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<PagedList<Report3Item>>)
            .then(result => {
                runInAction("fetch complete loadData", () => {
                    this.currentPage = page;
                    this.totalOrdersCount = result.totalItemCount;
                    this.items = result.items;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    loadBrands(customerId: string, managerIds: string[], statuses: number[], source?: string, dateFrom?: Date, dateTo?: Date, page = 1) {
        const managerIdsParam = managerIds.length <= 0 ? "" : "&managerIds=" + managerIds.join("&managerIds=");
        const statusesParam = statuses.length <= 0 ? "" : "&statuses=" + statuses.join("&statuses=");
        const dateFromStr = dateFrom == undefined ? '' : formatDateJson(dateFrom);
        const dateToStr = dateTo == undefined ? '' : formatDateJson(dateTo);



        fetchWrapper(`api/report3/getbrandsdata?source=${source}&page=${page}&customerId=${customerId}&dateFrom=${dateFromStr}&dateTo=${dateToStr}${managerIdsParam}${statusesParam}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<PagedList<Report3BrandInfoItem>>)
            .then(result => {

                runInAction("fetch complete loadBrands", () => {
                    this.items = this.items.map(w => Object.assign({}, w, {
                        brands: w.userId == customerId ?
                            (page > 1 ? [...w.brands, ...result.items] : result.items) : []
                    }));
                    this.brandsCurrentPage = result.pageNumber;
                    this.brandsTotalItemsCount = result.totalItemCount;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    hideBrands() {
        runInAction("fetch complete loadBrands", () => {
            this.items = this.items.map(w => Object.assign({}, w, { brands: [] }));
        });
    }

}